import { notification } from "antd";
import { editGrainReceivingPoint } from "../store/buyers.store";
import { IReceivingPoint } from "../ts";

export const handleUpdate = async ({
    nameString,
    hasMixer,
    pointName,
    pointForEditId,
    clearValue,
    state,
  }: {
    pointName: IReceivingPoint;
    pointForEditId: number;
    hasMixer: number;
    clearValue?: () => void;
    state?: 'enabled' | 'disabled',
    nameString: string,
  }) => {
    let resGl;
    try {
      const res: any = await editGrainReceivingPoint({
        id: pointForEditId,
        name: nameString,
        region: pointName.region,
        city: pointName.area,
        street: pointName.street,
        house: pointName.house,
        latitude: pointName.latitude, 
        longitude: pointName.longitude,
        enabled: pointName.enabled,
        has_mixer: hasMixer,
      });
      resGl = res;
      if (res.error) {
          return notification.error({
            message: typeof res.error === 'string' ? res.error : 'Непредвиденная ошибка. Попробуйте позже.',
          });
      }
    } catch (err) {
      return notification.error({
        message: 'Непредвиденная ошибка. Попробуйте позже.',
      });
    
    }
    if (state) {
      let msg = '';
      state === 'disabled' ? msg = 'Пункт приема успешно включен' : msg = 'Пункт приема успешно отключен'
      notification.success({ message: msg })
      clearValue && clearValue();
      return;
    }
    notification.success({ message: 'Пункт приема успешно обновлен' })
    clearValue && clearValue();
    return resGl;
  };